module.exports = __webpack_public_path__ + "img/i_c_new_02.a5287003.svg";